// Explicit model mapping: do not assume every BMC steerer accepts an ICS cockpit.
export function bmcCockpitName(frame) {
  const name = (frame && frame.name || '').trim();
  if (/^BMC Teammachine SLR\s*01$/i.test(name)) return 'BMC ICS Carbon EVO';
  if (/^BMC Teammachine R\s*01$/i.test(name)) return 'BMC ICS Carbon Aero';
  if (/^BMC Kaius\s*01$/i.test(name)) return /Gen\s*1/i.test(frame.description || '')
    ? 'BMC ICS Carbon Aero' : 'BMC ICS Carbon Aero Gen2';
  return null;
}

export function bmcBarsForFrame(bars, frame) {
  const preferred = bmcCockpitName(frame);
  return bars.filter(bar => !/^BMC ICS Carbon\b/.test(bar.name || '') || bar.name === preferred);
}

// Called only on a user frame selection, never when restoring a saved build.
export function preselectBmcCockpit(selection, frame, bars, steps) {
  const preferred = bmcCockpitName(frame);
  const options = bmcBarsForFrame(bars, frame);
  const current = selection.find(entry => entry.props.id === 'bars');
  const next = selection.filter(entry => entry.props.id !== 'bars' || options.some(bar => bar.id === entry.item.id));
  const stepIndex = steps.findIndex(step => step.id === 'bars');
  if (stepIndex < 0) return next;
  const removedBmc = current && /^BMC ICS Carbon\b/.test(current.item.name || '') && !next.includes(current);
  const bar = preferred ? options.find(item => item.name === preferred)
    : removedBmc ? options.find(item => /enve/i.test(item.name || '')) || options[0] : null;
  if (!bar) return next;
  if (current && current.item.id === bar.id) return next;
  const step = steps[stepIndex];
  const entry = { props: step, selected: 0, item: { ...bar, type: 'bars', step }, color: 0 };
  const index = next.findIndex(item => item.props.id === 'bars');
  if (index >= 0) next.splice(index, 1, entry);
  else next.splice(Math.min(stepIndex, next.length), 0, entry);
  return next;
}
